import * as types from '../constants/officeRunnerConstants'

export default utm => ({ type: types.SAVE_UTM_PARAMS, utm })



// WEBPACK FOOTER //
// ./src/actions/saveUtmParams.js